import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import employeeService from "services/employee";

// Async thunk for creating a new employee
export const createEmployeeAsync = createAsyncThunk(
    "employee/create",
    async ({ data }, { rejectWithValue }) => {
        try {
            const res = await employeeService.create(data);
            return res.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
export const updateEmployeeAsync = createAsyncThunk(
    "employee/update",

    async ({ employeeId, data }, { rejectWithValue }) => {
        try {
            const res = await employeeService.update(employeeId, data);
            return res.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
// Async thunk for fetching employees based on companyId
export const getEmployeeAsync = createAsyncThunk(
    "employee/getByCompany",
    async ({ companyId }, { rejectWithValue }) => {
        try {
            const res = await employeeService.getCompanyEmployee(companyId);
            return res.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
export const getOrganizationEmployeeAsync = createAsyncThunk(
    "employee/getByOrganization",  // <-- Updated action type
    async ({ organizationId }, { rejectWithValue }) => {
        try {
            const res = await employeeService.getOrganizationEmployee(organizationId);
            return res.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const removeEmployeeAsync = createAsyncThunk(
    "employee/remove",
    async ({ employeeId }, { rejectWithValue }) => {
        try {
            const res = await employeeService.remove(employeeId);
            return res.data
        } catch (error) {
            return rejectWithValue(error);
        }
    }
)

const initialState = {
    createEmployeeStatus: {
        status: "idle",
        error: null,
        data: null,
    },
    updateEmployeeStatus: {
        status: "idle",
        error: null,
    },
    removeEmployeeStatus: {
        status: "idle",
        error: null,
    },
    getEmployeeStatus: {
        status: "idle",
        error: null,
    },
    getEmployee: {
        items: [],
        totalCount: 0,
    },
    getOrganizationEmployeeStatus: {
        status: "idle",
        error: null,
    },
    getOrganizationEmployee: {
        items: [],
        totalCount: 0,
    },
};

const employeeSlice = createSlice({
    name: "employee",
    initialState,
    reducers: {
        resetCreatingEmployeeStatus: (state) => {
            state.createEmployeeStatus = initialState.createEmployeeStatus;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(createEmployeeAsync.pending, (state) => {
                state.createEmployeeStatus.status = "loading";
                state.createEmployeeStatus.error = null;
                state.createEmployeeStatus.data = null;
            })
            .addCase(createEmployeeAsync.fulfilled, (state, action) => {
                state.createEmployeeStatus.status = "succeeded";
                state.createEmployeeStatus.data = action.payload;
            })
            .addCase(createEmployeeAsync.rejected, (state, action) => {
                state.createEmployeeStatus.status = "failed";
                state.createEmployeeStatus.error = action?.payload?.messageText;
            })
            .addCase(getEmployeeAsync.pending, (state) => {
                state.getEmployeeStatus.status = "loading";
                state.getEmployeeStatus.error = null;
                state.getEmployeeStatus.data = null;
            })
            .addCase(getEmployeeAsync.fulfilled, (state, action) => {
                state.getEmployeeStatus.status = "succeeded";
                state.getEmployee = action.payload.employee;
            })
            .addCase(getEmployeeAsync.rejected, (state, action) => {
                state.getEmployeeStatus.status = "failed";
                state.getEmployeeStatus.error = action?.payload?.messageText;
            })
            .addCase(getOrganizationEmployeeAsync.pending, (state) => {
                state.getEmployeeStatus.status = "loading";
                state.getEmployeeStatus.error = null;
                state.getEmployeeStatus.data = null;
            })
            .addCase(getOrganizationEmployeeAsync.fulfilled, (state, action) => {
                state.getEmployeeStatus.status = "succeeded";
                state.getEmployee = action.payload.employee;
            })
            .addCase(getOrganizationEmployeeAsync.rejected, (state, action) => {
                state.getEmployeeStatus.status = "failed";
                state.getEmployeeStatus.error = action?.payload?.messageText;
            })
            .addCase(removeEmployeeAsync.pending, (state) => {
                state.removeEmployeeStatus.status = "loading";
                state.removeEmployeeStatus.error = null;
            })
            .addCase(removeEmployeeAsync.fulfilled, (state, action) => {
                state.removeEmployeeStatus.status = "succeeded";
            })
            .addCase(removeEmployeeAsync.rejected, (state, action) => {
                state.removeEmployeeStatus.status = "failed";
                state.removeEmployeeStatus.error = action?.payload?.messageText;
            });
    },
});

export const { resetCreatingEmployeeStatus } = employeeSlice.actions;

export default employeeSlice.reducer;
